import React from 'react';
import PropTypes from 'prop-types';

const MESSAGE_TYPE = {
  COMPLETE: 'COMPLETE',
  INCOMPLETE: 'INCOMPLETE',
};

/**
 *  MultiSelectFeedback:
 *  - Component checks answerIds and checkboxes in MultiSelect Quetion
 *     and determine the feedback to display.
 */
export function MultiSelectFeedback(props) {
  let messageType = MESSAGE_TYPE.INCOMPLETE;
  const allSubmittedOptions = props.checkboxes.reduce((list, checkbox) => {
    if (checkbox.disabled) list.push(checkbox.id);
    return list;
  }, []);
  const isAllAnswersSumitted = props.answerId.every((answer) =>
    allSubmittedOptions.includes(answer)
  );

  if (allSubmittedOptions.length) {
    if (isAllAnswersSumitted) messageType = MESSAGE_TYPE.COMPLETE;
    return React.cloneElement(props.children, {
      className: `${
        props.children.props.className
      } ${messageType.toLowerCase()}`,
      messageType,
    });
  } else {
    return null;
  }
}

MultiSelectFeedback.propTypes = {
  /**
   * The list of ID's for the correct Options
   */
  answerId: PropTypes.arrayOf(PropTypes.number).isRequired,
  /**
   * The list of options.
   */
  checkboxes: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * The component that render the feedback message
   */
  children: PropTypes.element.isRequired,
};

MultiSelectFeedback.defaultProps = {};
